/* GEEEKART 环氧树脂计算器（纯前端，无依赖） */
(function () {
  var root = document.querySelector('[data-gc-calc]');
  if (!root) return;

  var state = { shape: 'rect', unit: root.dataset.unit === 'cm' ? 'cm' : 'in', waste: 10 };

  var IN2L = 0.016387064; // 立方英寸 → 升
  var IN2OZ = 0.5541128;  // 立方英寸 → 美制液盎司
  var IN2GAL = 1 / 231;   // 立方英寸 → 美制加仑

  function $(sel, scope) { return (scope || root).querySelector(sel); }
  function $$(sel, scope) { return Array.prototype.slice.call((scope || root).querySelectorAll(sel)); }

  function dimInput(name) { return $('[data-dim="' + name + '"]', root); }

  function num(el) {
    var v = parseFloat(el && el.value);
    return isFinite(v) && v > 0 ? v : 0;
  }

  function toInches(v) { return state.unit === 'cm' ? v / 2.54 : v; }

  function fmt(n, big) {
    if (n >= 100) return n.toFixed(0);
    if (n >= 10) return n.toFixed(1);
    return n.toFixed(big ? 2 : 2);
  }

  function tierOf(thIn) {
    if (thIn <= 0.25) return 'coating';
    if (thIn <= 1) return 'mid';
    return 'deep';
  }

  var TIER_TEXT = {
    coating: 'Thin flood coat · up to 1/4"',
    mid: 'Medium casting · 1/4" – 1"',
    deep: 'Deep pour · over 1"'
  };

  function compute() {
    var th = toInches(num(dimInput('th')));
    var vin = 0;
    if (state.shape === 'rect') {
      vin = toInches(num(dimInput('len'))) * toInches(num(dimInput('wid'))) * th;
    } else {
      var d = toInches(num(dimInput('dia')));
      vin = Math.PI * Math.pow(d / 2, 2) * th;
    }
    var total = vin * (1 + state.waste / 100);

    $('[data-out="liters"]').textContent = total > 0 ? fmt(total * IN2L, true) : '0.00';
    $('[data-out="floz"]').textContent = total > 0 ? fmt(total * IN2OZ) : '0';
    $('[data-out="gal"]').textContent = total > 0 ? fmt(total * IN2GAL) : '0.00';

    var tier = tierOf(th);
    $('[data-out="tier"]').textContent = TIER_TEXT[tier];

    $$('[data-tier]', root).forEach(function (pick) {
      pick.hidden = pick.dataset.tier !== tier;
    });

    // 厚度提示
    var hint = $('[data-out="pourhint"]');
    if (hint) {
      if (th > 1) {
        hint.hidden = false;
        hint.textContent = 'Deep pour: split into multiple layers and follow the kit’s max pour depth.';
        hint.classList.add('gc-calc__hint--warn');
      } else if (th > 0 && th <= 0.125) {
        hint.hidden = false;
        hint.textContent = 'Thin flood coat range — a seal coat first helps reduce bubbles on porous wood.';
        hint.classList.remove('gc-calc__hint--warn');
      } else {
        hint.hidden = true;
      }
    }
  }

  /* 形状 / 单位分段按钮 */
  $$('[data-shape]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.shape = btn.dataset.shape;
      $$('[data-shape]').forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });
      $$('[data-for]').forEach(function (wrap) {
        var show = wrap.dataset.for === state.shape || wrap.dataset.for === 'both';
        wrap.hidden = !show;
      });
      compute();
    });
  });

  $$('[data-unit]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var next = btn.dataset.unit;
      if (next === state.unit) return;
      // 换算已输入的数值
      $$('[data-dim]').forEach(function (inp) {
        var v = parseFloat(inp.value);
        if (isFinite(v) && v > 0) {
          // 保留 4 位小数，避免 0.25"→0.64cm 这类舍入导致回算越界跳档
          inp.value = (next === 'cm' ? v * 2.54 : v / 2.54).toFixed(4).replace(/\.?0+$/, '');
        }
      });
      state.unit = next;
      $$('[data-unit]').forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });
      $$('[data-unit-label]').forEach(function (s) { s.textContent = next; });
      compute();
    });
  });

  /* 尺寸输入 */
  $$('[data-dim]').forEach(function (inp) {
    inp.addEventListener('input', compute);
  });

  /* 厚度快捷 chips（data-th 为英寸） */
  $$('[data-th]').forEach(function (chip) {
    chip.addEventListener('click', function () {
      var thIn = parseFloat(chip.dataset.th);
      var v = state.unit === 'cm' ? thIn * 2.54 : thIn;
      dimInput('th').value = String(Math.round(v * 100) / 100);
      compute();
    });
  });

  /* 损耗滑杆 */
  var waste = $('[data-waste]');
  if (waste) {
    waste.addEventListener('input', function () {
      state.waste = parseInt(waste.value, 10) || 0;
      $('[data-waste-val]').textContent = state.waste + '%';
      compute();
    });
  }

  /* 初始状态同步 */
  $$('[data-for]').forEach(function (wrap) {
    wrap.hidden = !(wrap.dataset.for === state.shape || wrap.dataset.for === 'both');
  });
  compute();
})();
